import React, { useState } from "react";
import { Select, Table } from "antd";

export const TopLocations = ({ data }) => {
  const uniqueDepartment = Array.from(
    new Set(data?.map((item) => item.department))
  );
  const uniqueProvince = Array.from(new Set(data?.map((item) => item.province)));
  const uniqueDistrict = Array.from(new Set(data?.map((item) => item.district)));

  const [filterLocation, setFilterLocation] = useState("department");
  const [selectedFilter, setSelectedFilter] = useState(null);

  const filteredData = data?.filter((item) => {
    if (filterLocation === "department") {
      if (selectedFilter && selectedFilter !== item.department) {
        return false;
      }
    }
    if (filterLocation === "province") {
      if (selectedFilter && selectedFilter !== item.province) {
        return false;
      }
    }
    if (filterLocation === "district") {
      if (selectedFilter && selectedFilter !== item.district) {
        return false;
      }
    }

    return true;
  });

  const orderCounts = {};
  data?.forEach((order) => {
    const location =
      filterLocation === "department"
        ? order.department
        : filterLocation === "province"
        ? order.province
        : order.district;
    orderCounts[location] = (orderCounts[location] || 0) + 1;
  });

  const getTotalByLocation = (location) => {
    let total = 0;
    filteredData?.forEach((order) => {
      const orderLocation =
        filterLocation === "department"
          ? order.department
          : filterLocation === "province"
          ? order.province
          : order.district;
      if (orderLocation === location) {
        total += 1;
      }
    });
    return total;
  };

  const getTotalProductsByLocation = (location) => {
    let total = 0;
    filteredData?.forEach((order) => {
      const orderLocation =
        filterLocation === "department"
          ? order.department
          : filterLocation === "province"
          ? order.province
          : order.district;
      if (orderLocation === location) {
        total += order.products?.reduce((acc, item) => acc + item.quantity, 0);
      }
    });
    return total;
  };

  const getTotalAmountByLocation = (location) => {
    let total = 0;
    filteredData?.forEach((order) => {
      const orderLocation =
        filterLocation === "department"
          ? order.department
          : filterLocation === "province"
          ? order.province
          : order.district;
      if (orderLocation === location) {
        total += order.saleAmount;
      }
    });
    return total;
  };

  const handleFilterTypeChange = (value) => {
    setFilterLocation(value);
    setSelectedFilter(null);
  };

  const columns = [
    {
      title: (
        <div>
          <Select
            defaultValue={filterLocation}
            onChange={handleFilterTypeChange}
            style={{ marginLeft: "1rem", width: 140 }}
          >
            <Select.Option value="department">Departamento</Select.Option>
            <Select.Option value="province">Provincia</Select.Option>
            <Select.Option value="district">Distrito</Select.Option>
          </Select>
        </div>
      ),
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Total de Ordenes",
      dataIndex: "total",
      key: "total",
      render: (text) => {
        const total = parseFloat(text);
        if (!isNaN(total)) {
          return `${total}`;
        }
        return "";
      },
      width: 120,
      sorter: (a, b) => a.total - b.total,
      sortDirections: ["descend", "ascend"],
      defaultSortOrder: "descend",
    },
    {
      title: "Total de Productos",
      dataIndex: "totalProducts",
      key: "totalProducts",
      sorter: (a, b) => a.totalProducts - b.totalProducts,
      sortDirections: ["descend", "ascend"],
      width: 120,
    },
    {
      title: "Total Facturado",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (text) => {
        const total = parseFloat(text);
        if (!isNaN(total)) {
          return `S/ ${total.toFixed(2)}`;
        }
        return "";
      },
      sorter: (a, b) => a.totalAmount - b.totalAmount,
      sortDirections: ["descend", "ascend"],
      width: 120,
    },
    {
      title: "% Total Ordenes",
      dataIndex: "percent",
      key: "percent",
      width: 120,
      render: (_, record) => {
        const total = filteredData.length;
        const percent = ((record.total / total) * 110).toFixed(2);
        return `${percent}%`;
      },
    },
  ];

  const dataSource =
    filterLocation === "department"
      ? uniqueDepartment.map((department) => ({
          location: department,
          total: getTotalByLocation(department),
          totalProducts: getTotalProductsByLocation(department),
          totalAmount: getTotalAmountByLocation(department),
          key: department,
        }))
      : filterLocation === "province"
      ? uniqueProvince.map((province) => ({
          location: province,
          total: getTotalByLocation(province),
          totalProducts: getTotalProductsByLocation(province),
          totalAmount: getTotalAmountByLocation(province),
          key: province,
        }))
      : uniqueDistrict.map((district) => ({
          location: district,
          total: getTotalByLocation(district),
          totalProducts: getTotalProductsByLocation(district),
          totalAmount: getTotalAmountByLocation(district),
          key: district,
        }));

  return (
    <div className="w-full pt-4 pr-4 pl-4">
       <div className="overflow-x-auto h-96">
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
       </div>
    </div>
  );
};
